const triggerOffCanvas = (id) => {
  console.log("this is id from utlis", id);

  const offcanvasMobileMenu = document.querySelector(id);
  return offcanvasMobileMenu.classList.add("active");
};

export default triggerOffCanvas;
